import { combineReducers } from 'redux';
import { MobileNumberReducer as mobileNumber } from './MobileNumberCard';
import { OtpCodeReducer as otpCode } from './OtpCodeCard';
import { passwordReducer as password } from './PasswordCard';
import { usernameReducer } from './UsernameCard';
import { otpTokenReducer as otpToken } from './OtpTokenCard';

export default combineReducers({
  mobileNumber,
  otpCode,
  password,
  usernameReducer,
  otpToken,
});
